import React, { PropTypes } from 'react';

// Components
import GoogleMap from 'google-map-react';
import PreDefinedLocal from './PreDefinedLocal';
import FotosGeoreferenciadas from './FotosGeoreferenciadas';
import PointAndRectList from './PointAndRectList';
import PasteArea from './PasteArea';

// Libs
import { isEqual } from 'lodash';
import { drawPoints, drawRects } from '../../businessLogic/map';
import { shouldUpdatePoint } from '../../businessLogic/util';
import NovoPonto from './NovoPonto';
import NovoRetangulo from './NovoRetangulo';

export default class Local extends React.Component {

	constructor(props) {
		super(props);
		this.state = { 
			checked: "predefined", 
			custom: "point",
			mapLoaded: false, 
			hasDrawnPoints: false
		};
	}

	componentWillMount() {
		this.props.getShapes();
	}

	componentDidUpdate(prevProps, prevState) {
		const { points, rects } = this.props;
		const { setLat, setLng } = this.props.actions;

		if ( !this.state.mapLoaded ) return;
		
		// If there's no change in points or the map hasn't changed from unloaded to loaded, return
		if ( (prevState.mapLoaded || !this.state.mapLoaded) && 
			(isEqual(prevProps.points, points) && isEqual(prevProps.rects, rects)) ) return;

		// Draw points
		drawPoints(points, this.google.map);
		// Draw rects
		drawRects(rects, this.google.map);		
		
		// Remove (if any) listener, and then add listener for dragging features
		if ( typeof this.listener !== "undefined" ) this.google.maps.event.removeListener(this.listener);
		this.listener = this.google.map.data.addListener('mouseup', (e) => {
			const newPoints = [];
			e.feature.getGeometry()
				.forEachLatLng((latLng) => newPoints.push({lat: latLng.lat().toString(), lng: latLng.lng().toString()}));

			newPoints.map((p, i) => {						
				const savedPoint = points[i];
				if ( shouldUpdatePoint(savedPoint, p) ) {
					setLat(p.lat, i);
					setLng(p.lng, i);
				}
			});
			this.updateToCustom();
		});

		// Remove (if any) listener, and then add listener for clicking features
		const map = this.google.map;
		const { createPoint } = this.props.actions;
		if ( typeof this.clickListener !== "undefined" ) this.google.maps.event.removeListener(this.clickListener);
		this.clickListener = map.addListener("click", (e) => {

			// Do not allow click if the focus isn't on point
			if ( this.state.checked === "predefined" || this.state.custom !== "point" ) return;

			const lat = e.latLng.lat().toString();
			const lng = e.latLng.lng().toString();
			if ( typeof points[0] !== "undefined" && points[0].lat === "" && points[0].lng === "" ) {
				setLat(lat, 0);
				setLng(lng, 0);
			} else createPoint({lat: lat, lng: lng});
			this.updateToCustom();
		});
		// disable when points
		this.setState({hasDrawnPoints: true});
		// const arrPoints = this.props.points;
		// if ( (typeof arrPoints !== "undefined" && arrPoints.length > 0) && 
		// 	!(typeof this.props.sectors !== "undefined" && this.props.sectors.length > 0) ) {
		// 	this.props.isFetchingMapFunc(true);
		// }
		
	}	

	handleGoogleMapApi(google) {		
		this.google = google;
		this.setState({mapLoaded: true});		

		// Listener for clicking on map
		const map = google.map;
		this.clickListener = map.addListener("click", (e) => {

			// Do not allow click if the focus isn't on point
			if ( this.state.checked === "predefined" || this.state.custom !== "point" ) return;
			
			const lat = e.latLng.lat().toString();
			const lng = e.latLng.lng().toString();
			this.props.actions.createPoint({lat: lat, lng: lng});
			this.updateToCustom();
		});				
	}

	onPredefinedAdd(options) {
		this.props.isFetchingMapFunc(false);
		if ( typeof this.google === "undefined" ) return;
		const map = this.google.map;
		let qtdeDocs = options.length;

		options.map((o) => {

			const shape = this.props.shapes.find((shape) => shape.id === o.value);
			this.props.actions.getGeom(shape.id, map, true, 'documents', () => {
				qtdeDocs = qtdeDocs - 1;
				if (qtdeDocs === 0) {
					this.props.isFetchingMapFunc(true);
				}
			});

		});
	}	

	onPredefinedRemove(options) {

		if ( typeof this.google === "undefined" ) return;
		const map = this.google.map;
		options.map((o) => {
			const feature = map.data.getFeatureById(o.value);
			if ( typeof feature !== "undefined" ) map.data.remove(feature);
		});
	}

	updateToCustom() {

		if ( this.state.checked === "predefined" ) this.setState({checked: "custom"});
	}

	// function renders load icon in map
	renderLoad() {
		if ( !this.state.hasDrawnPoints ) {
			return ( 
				<div className="centerSpin" style={{width: "100%", height: "500px",
					fontSize: '13rem', color: '#ffffff', opacity: 0.5,
					textShadow: '0 0 3px #666666', position: 'absolute', zIndex: 999999}}>
					<div>
						<i className="fas fa-circle-notch fa-spin" />
					</div>
				</div>
			);
		}
	}
	
	render () {

		return (
			<div>
				<label>Localização</label>

				<div className="row">
					<div className="col-md-8">
						<div style={{width: "100%", height: "500px"}}>
							{this.renderLoad()}
							<GoogleMap
								bootstrapURLKeys={
								{
									key: "AIzaSyA7pbCrlAlFUZLlWPSriQWUIYUk8__7JLM",
									language: 'pt-BR'
								}
								}												
								center={{lat: -20.049293182101255, lng: -42.82365408697386}}
								options={{streetViewControl: true, mapTypeId: 'satellite'}}
								defaultZoom={7}
								yesIWantToUseGoogleMapApiInternals
								onGoogleApiLoaded={this.handleGoogleMapApi.bind(this)}							
							/>
						</div>
					</div>	

					<div className="panel-map-options col-md-4">
						<label className='center'>Pré-Definida</label>

						<PreDefinedLocal 
							mapLoaded={this.state.mapLoaded}
							setSectors={this.props.actions.setSectors}
							sectors={this.props.sectors} 
							setLocalities={this.props.actions.setLocalities}
							localities={this.props.localities}
							setSamplingPoints={this.props.actions.setSamplingPoints}
							samplingPoints={this.props.samplingPoints}
							shapes={this.props.groupedShapes.predefined}
							onAdd={this.onPredefinedAdd.bind(this)}
							onRemove={this.onPredefinedRemove.bind(this)}					
						/>

						<label className='center'>Customizada</label>
						
						<div className='row'>
							<div className='col-md-6 col-xs-3' style={{'margin-top': '10px'}}>
								<NovoPonto 
									points={this.props.points}
									createPoint={this.props.actions.createPoint}
									setIsCreatingPoint={this.props.actions.setIsCreatingPoint}
									setPoints={this.props.actions.setPoints}
									setLat={this.props.actions.setLat}
									setLng={this.props.actions.setLng}
									addPointImage={this.props.actions.addPointImage}
									addPointImageWithSrc={this.props.actions.addPointImageWithSrc}
									removePointImage={this.props.actions.removePointImage}
									removeSavedPointImage={this.props.actions.removeSavedPointImage}
									setPointSrc={this.props.actions.setPointSrc}
									setPointCaption={this.props.actions.setPointCaption}
									setPointLabel={this.props.actions.setPointLabel}
									removePoint={this.props.actions.removePoint}
									checkExistance={this.props.checkExistance}
								/>
							</div>
							<div className='col-md-6 col-xs-3' style={{'margin-top': '10px'}}>
								<NovoRetangulo 
									rects={this.props.rects}
									createRect={this.props.actions.createRect}
									removeRect={this.props.actions.removeRect}
									setIsCreatingRect={this.props.actions.setIsCreatingRect}
									setLatNw={this.props.actions.setLatNw}
									setLngNw={this.props.actions.setLngNw}
									setLatSe={this.props.actions.setLatSe}
									setLngSe={this.props.actions.setLngSe}
								/>
							</div>

							<div className='col-md-6 col-xs-3' style={{'margin-top': '10px'}}>
								<PasteArea points={this.props.points} createPoint={this.props.actions.createPoint} />
							</div>

							<div className='col-md-6 col-xs-3' style={{'margin-top': '10px'}}>
								<FotosGeoreferenciadas 
									points={this.props.points}
									createPoint={this.props.actions.createPoint}
									createPointRaw={this.props.actions.createPointRaw}
									addPointImageWithSrc={this.props.actions.addPointImageWithSrc}
									checkExistance={this.props.checkExistance}
								/>
							</div>
						</div>
						<br />
						<label className='center'>Atenção!</label>

						<div className='row'>
							<div className='col-md-12'>
								<ul style={{padding: '15px'}}>
									<li>Sistema de referência WGS 84 ou SIRGAS 2000.</li>
									<li>Usar Graus Decimais (GD).</li>
									<li>Não utilizar o sistema de projeção UTM.</li>
								</ul>
							</div>
						</div>
					</div>			
				</div>

				<br />
				
				<PointAndRectList 
					points={this.props.points}
					setPoints={this.props.actions.setPoints}
					createPoint={this.props.actions.createPoint}
					setLat={this.props.actions.setLat}
					setLng={this.props.actions.setLng}
					addPointImage={this.props.actions.addPointImage}
					addPointImageWithSrc={this.props.actions.addPointImageWithSrc}
					removePointImage={this.props.actions.removePointImage}
					removeSavedPoint={this.props.actions.removeSavedPoint}
					removeSavedPointImage={this.props.actions.removeSavedPointImage}
					setPointSrc={this.props.actions.setPointSrc}
					setPointCaption={this.props.actions.setPointCaption}
					setPointLabel={this.props.actions.setPointLabel}
					setSavedPointCaption={this.props.actions.setSavedPointCaption}
					removePoint={this.props.actions.removePoint}
					rects={this.props.rects}
					createRect={this.props.actions.createRect}
					removeRect={this.props.actions.removeRect}
					setLatNw={this.props.actions.setLatNw}
					setLngNw={this.props.actions.setLngNw}
					setLatSe={this.props.actions.setLatSe}
					setLngSe={this.props.actions.setLngSe}
					custom={this.state.custom}
					onChange={(value) => this.setState({custom: value})}
					checkExistance={this.props.checkExistance}
				/>
			</div>
		);
	}
}

Local.propTypes = {
	actions: PropTypes.object.isRequired,
	sectors: PropTypes.array.isRequired,
	localities: PropTypes.array.isRequired,
	samplingPoints: PropTypes.array.isRequired,
	isFetchingMap: PropTypes.bool.isRequired,
	isFetchingMapFunc: PropTypes.func.isRequired,
	points: PropTypes.array.isRequired,
	rects: PropTypes.array.isRequired,
	shapes: PropTypes.array.isRequired,
	groupedShapes: PropTypes.object.isRequired,
	getShapes: PropTypes.func.isRequired,
	checkExistance: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/components/Documents/Local.js